module.exports = __webpack_public_path__ + "static/img/weilan.abb36e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/taidi/weilan.png
// module id = Uyyf
// module chunks = 19